module.exports = "<svg class=\"Polaris-Icon__Svg\" viewBox=\"0 0 20 20\"><path d=\"M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm-1-8h2V6H9v4zm0 4h2v-2H9v2z\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/resources/checkbox-error-icon.svg
// module id = 242
// module chunks = 0